import React, { FC, ReactNode } from 'react'
import { FormikProps } from 'formik'
import DateObject from 'react-date-object'
import { Value as TValueDate } from 'react-multi-date-picker'
import Calendar from '../Calendar'

export interface ICalendarForm {
  onOpenPickNewDate?: boolean
  formik: FormikProps<any>
  name: string
  children?: ReactNode
  formatTo?: string
  format?: string
  render?: React.ReactElement | Function
}

const CalendarForm: FC<ICalendarForm> = ({
  name,
  formik,
  children,
  formatTo = 'DD-MM-YYYY',
  format = 'DD.MM.YYYY',
  onOpenPickNewDate = true,
  ...props
}) => {
  const { setFieldValue, getFieldMeta } = formik;

  const {value} = getFieldMeta(name);

  const onChangeField = (date: DateObject | DateObject[] | null) => {
    let val: DateObject | DateObject[] | null | string = date;
    if (date instanceof DateObject && formatTo) {
      val = date ? date.format(formatTo) : date;
    }
    setFieldValue(name, val);
  };

  return (
    <Calendar
      value={value as TValueDate}
      onChange={onChangeField}
      name={name}
      format={format}
      onOpenPickNewDate={onOpenPickNewDate}
      {...props}
    >
      {children}
    </Calendar>
  );
};

export default CalendarForm;
